import React, { useEffect } from "react";

export function NameAndHub({ name, hub }) {
  const removeNullValue = () => {
    // console.log(hub);
  };

  useEffect(() => {
    removeNullValue();
  }, []);

  return (
    <>
      {" "}
      <div className="basic-details-name"> {name} </div>
      <div className="basic-details-hub">{hub} </div>
    </>
  );
}
